import createDomPurify from 'dompurify';

/**
 * Instance of DOMPurify with a hook to set target="_blank" for all links
 * isolated to prevent adding hooks to global dompurify configuration.
 *
 * @type {import('dompurify').DOMPurify}
 */
const noAnchorTargetsDompurify = createDomPurify();
// replace anchor targets with target="_blank" for all links that don't have an anchor
noAnchorTargetsDompurify.addHook('afterSanitizeAttributes', node => {
	if ('target' in node && node.href.search('#') === -1) {
		node.setAttribute('target', '_blank');
		node.setAttribute('data-mangled', 'true');
	}
});

export { noAnchorTargetsDompurify };
